<template>
  <div class="mpm-input-wrapper">
    <a-input
      ref="input"
      :value="innerValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxLength="maxLength"
      :allowClear="allowClear"
      :size="size"
      :type="type"
      @input="onInput"
      @change="onChange"
      @pressEnter="onPressEnter"
      @focus="onFocus"
      @blur="onBlur"
      v-bind="$attrs"
    >
      <template v-if="$slots.prefix" slot="prefix">
        <slot name="prefix" />
      </template>
      <template v-if="$slots.suffix" slot="suffix">
        <slot name="suffix" />
      </template>
    </a-input>
  </div>
</template>

<script>
  export default {
    name: 'MpmInput',
    inheritAttrs: false,
    props: {
      // 输入框的值
      value: {
        type: [String, Number],
        default: '',
      },
      // 占位符
      placeholder: {
        type: String,
        default: '请输入',
      },
      // 是否禁用
      disabled: {
        type: Boolean,
        default: false,
      },
      // 最大长度
      maxLength: {
        type: [String, Number],
        default: undefined,
      },
      // 是否可清除
      allowClear: {
        type: Boolean,
        default: false,
      },
      // 输入框大小
      size: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['large', 'default', 'small'].indexOf(value) !== -1
        },
      },
      // 输入框类型
      type: {
        type: String,
        default: 'text',
      },
      // 是否自动去除前后空格
      trim: {
        type: Boolean,
        default: true,
      },
      // 是否过滤所有空格
      filterSpace: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        innerValue: this.formatValue(this.value),
        isComposing: false, // 用于处理中文输入
      }
    },
    watch: {
      value: {
        handler(newVal) {
          this.innerValue = newVal
        },
        immediate: true,
      },
    },
    methods: {
      // 格式化值
      formatValue(val) {
        if (val === null || val === undefined) {
          return ''
        }
        let formattedValue = String(val)
        // 过滤所有空格
        if (this.filterSpace) {
          formattedValue = formattedValue.replace(/\s/g, '')
        }
        // 去除前后空格
        else if (this.trim) {
          formattedValue = formattedValue.trim()
        }
        return formattedValue
      },
      // 处理输入事件
      onInput(e) {
        // 获取输入值并格式化
        const value = e.target.value
        // 更新内部值
        this.innerValue = value
        this.$emit('input', value)
      },
      // 处理change事件
      onChange(e) {
        const value = this.formatValue(e.target.value)
        this.$emit('change', value)
      },
      // 处理回车事件
      onPressEnter(e) {
        const value = this.formatValue(e.target.value)
        this.$emit('pressEnter', value)
      },
      // 处理获得焦点事件
      onFocus(e) {
        this.$emit('focus', e)
      },
      // 处理失去焦点事件
      onBlur(e) {
        // 在失去焦点时确保进行最后的格式化
        const value = this.formatValue(e.target.value)
        if (this.innerValue !== value) {
          this.innerValue = value
          this.$emit('input', value)
        }
        this.$emit('blur', e)
      },
      // 对外暴露的方法：获取焦点
      focus() {
        this.$refs.input.focus()
      },
      // 对外暴露的方法：失去焦点
      blur() {
        this.$refs.input.blur()
      },
      // 对外暴露的方法：选择内容
      select() {
        this.$refs.input.select()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mpm-input-wrapper {
    display: inline-block;
    width: 100%;
  }
</style>
